import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ToasterService } from "angular2-toaster";
import { AlertMotionFacadeEntity } from "../../../../entities/alert";
import { AlertFacadeDefaultWidgetComponent } from "./default.widget.component";
import { AlertFacadeWidgetEventStruct } from "./alert-facade-widget-event.struct";

@Component({
  selector: "alert-facade-motion-widget",
  template: `
    <div class="card card-accent-dark alert-facade-motion-widget">
      <!-- Card Header -->
      <div class="card-header bg-dark text-white">
        <h5 class="mb-0">Motion Alert</h5>
      </div>

      <!-- Card Body -->
      <div class="card-body">
        <!-- Device Section -->
        <div class="row mb-3">
          <div class="col-4 font-weight-bold">Device</div>
          <div class="col-8">
            <a
              [routerLink]="'/portal/devices/show/' + entity.device"
              class="text-primary"
              >{{ entity.device }}</a
            >
          </div>
        </div>

        <!-- Association Section -->
        <div class="row mb-3">
          <div class="col-4 font-weight-bold">Association</div>
          <div class="col-8">{{ entity.deviceAssociation }}</div>
        </div>

        <hr class="my-3" />

        <!-- On Motion Section -->
        <div class="row mb-3">
          <div class="col-4 font-weight-bold">On Motion</div>
          <div *ngIf="!options?.edit" class="col-8 text-muted">
            {{ entity.triggerOnMotion | json }}
          </div>
          <div *ngIf="options?.edit" class="col-8">
            <label class="switch switch-3d switch-primary">
              <input
                class="switch-input switch-primary"
                (change)="facadeChange($event)"
                [(ngModel)]="entity.triggerOnMotion"
                type="checkbox"
              />
              <span class="switch-slider"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class EmbedAlertMotionFacadeComponent extends AlertFacadeDefaultWidgetComponent {
  public editMode = false;
  @Input() layout: string = null;
  @Input() entity: AlertMotionFacadeEntity;
  @Input() options: any;
  @Input() deviceData: any = null;

  @Output() widgetEvent = new EventEmitter<AlertFacadeWidgetEventStruct>();
  forwardEvent(e, widgetEvent: AlertFacadeWidgetEventStruct) {
    e.preventDefault();
    this.widgetEvent.emit(widgetEvent);
  }
  setDeviceValues() {
    if (!this.options.edit) return;
    this.entity.device = this.deviceData.deviceId;
    this.entity.deviceAssociation = this.deviceData.associationId;
  }
  constructor(public toasterService: ToasterService) {
    super();
  }
  ngOnInit() {
    if (
      this.deviceData.deviceId !== undefined &&
      this.deviceData.associationId !== undefined
    ) {
      this.setDeviceValues();
    }
  }
}
